// Components
import { TooltipHost } from "../tooltip/TooltipHost";
import { IconButton as FluentIconButton } from "@fluentui/react";
// Styles
import { getIconButtonStyles } from "./IconButton.styles";
// Utilities
import * as React from "react";
/**
 * IconButton control that customizes the fluent control to our own purposes
 */ export const IconButton = (props)=>{
    const { title, ...propsWithoutTitle } = props;
    let component;
    if (title) {
        // Use the title in a Fluent tooltip for accessibility.
        component = /*#__PURE__*/ React.createElement(TooltipHost, {
            content: title
        }, /*#__PURE__*/ React.createElement(FluentIconButton, {
            styles: getIconButtonStyles(),
            ...propsWithoutTitle
        }));
    } else {
        component = /*#__PURE__*/ React.createElement(FluentIconButton, {
            styles: getIconButtonStyles(),
            ...props
        });
    }
    return component;
};
